import { ADD_CATEGORIES } from './types'

export const addCategories = items => ({
  type: ADD_CATEGORIES,
  payload: { items }
})
